import { useField } from "formik";
import React from "react";
import Input from "./Input";
import InputPhone from "./InputPhone";
import CheckboxButton from "../CheckboxButton";

const InputField = (props) => {
  const [field, meta] = useField(props);

  return <Input {...field} {...props} />;
};

const CheckboxButtonField = (props) => {
  const [field, meta] = useField({ ...props, type: "checkbox" });
  return <CheckboxButton {...field} {...props} />;
};

const InputPhoneField = (props) => {
  const [field, meta, helpers] = useField(props);

  const { value } = meta;
  const { setValue, setTouched } = helpers;

  return (
    <InputPhone
      value={value}
      onChange={(data) => {
        setValue(data);
        setTimeout(() => setTouched(true));
      }}
      onBlur={() => setTouched(true)}
      {...props}
    />
  );
};

export { InputField, InputPhoneField, CheckboxButtonField };
